import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    lazy: page('DashboardPage'),
    handle: { title: '할 일', feature: 'TASKS' } satisfies RouteHandle,
  },
];
